export default "__VITE_ASSET__BQ0I2KwF__"